import { makeAutoObservable } from 'mobx';
import ErrorParsingService, {
  IErrorObject,
  IGraphQLErrorResponse,
  IGraphQLSubscriptionError
} from '../../utils/services/error-parsing-service';

class ErrorBoundaryStore {
  public errorMessage = '';
  private errorParsingService: ErrorParsingService;

  constructor () {
    makeAutoObservable(this);
    this.errorParsingService = new ErrorParsingService();
  }

  public setErrorMessage = (error: IErrorObject): void => {
    this.errorMessage = this.errorParsingService.extractErrorMessage(error);
  };

  public setErrorMessageExplicitly = (errorMessage:string): void => {
    this.errorMessage = errorMessage;
  };

  public setGraphQLErrorMessage = (error: IGraphQLErrorResponse): void => {
    const { errors: [extractedError] } = error;
    this.errorMessage = this.errorParsingService.extractGraphQLError(extractedError);
  };

  public setSubscriptionError = (error: IGraphQLSubscriptionError): void => {
    const { error: { errors: [extractedError] }} = error;
    this.errorMessage = this.errorParsingService.extractSubscriptionError(extractedError);
  };
}

export default ErrorBoundaryStore;
